import React from 'react';
import { getModuleTitle } from '../../lib/navigation';
import { Sparkles, ArrowRight, LayoutTemplate } from 'lucide-react';

export function ModulePlaceholder({ activeModule }: { activeModule: string }) {
  const title = getModuleTitle(activeModule);

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500 ease-out">
      <div className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8 shadow-sm">
        <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 mb-6 border border-indigo-100">
          <LayoutTemplate size={24} />
        </div>
        <h3 className="text-2xl font-display font-semibold text-gray-900 mb-3">
          {title}
        </h3>
        <p className="text-gray-500 mb-8 max-w-2xl text-base leading-relaxed">
          A estrutura de dados deste módulo já foi configurada no app shell. Em breve (Fase 2 e 3) esta tela receberá os componentes visuais, formulários dinâmicos e integrações de dados.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="border border-gray-100 bg-gray-50 rounded-xl p-5 hover:border-gray-200 transition-colors">
                <h4 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                    <span className="w-6 h-6 rounded bg-white border border-gray-200 flex items-center justify-center text-xs text-gray-500">1</span>
                    Campos Estruturados
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed">Dezenas de tipos de input previstos: Rich text, uploads, seletores múltiplos, máscaras financeiras e data/hora.</p>
            </div>
            <div className="border border-gray-100 bg-gray-50 rounded-xl p-5 hover:border-gray-200 transition-colors">
                <h4 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                    <span className="w-6 h-6 rounded bg-indigo-100 border border-indigo-200 flex items-center justify-center text-xs text-indigo-600"><Sparkles size={12}/></span>
                    Inteligência Artificial
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed">Sistema auto-alimentado. Os dados inseridos aqui treinam o assistente para gerar scripts e automações em outros módulos.</p>
            </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 flex items-center justify-between">
            <span className="text-xs font-medium text-gray-400 uppercase tracking-wider">Status: Mockup / Fase 1</span>
            <button className="flex items-center gap-2 text-sm font-semibold text-indigo-600 hover:text-indigo-700 transition-colors">
                Próxima fase <ArrowRight size={16} />
            </button>
        </div>
      </div>
    </div>
  );
}
